"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAuthenticator = void 0;
const react_1 = __importDefault(require("react"));
const msal_1 = require("msal");
const utils_1 = require("./utils");
let msalApp;
let ERROR;
let USER_ACCOUNT;
let AUTH_STATE;
let GRAPH_PROFILE;
let GRAPH_GROUPS;
const useRedirectFlow = utils_1.isIE();
const withAuthenticator = (Component, authenticatorProps) => {
    if (!msalApp) {
        msalApp = new msal_1.UserAgentApplication({
            auth: authenticatorProps,
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: useRedirectFlow,
            },
        });
    }
    const AppWithAuthenticator = (props) => {
        const acquireToken = async (request, redirect) => {
            const tokenData = await msalApp
                .acquireTokenSilent(request)
                .catch(async (err) => {
                if (utils_1.requiresInteraction(err.errorCode)) {
                    return redirect
                        ? msalApp.acquireTokenRedirect({
                            ...request,
                            redirectUri: authenticatorProps.redirectUri,
                        })
                        : msalApp.acquireTokenPopup(request);
                }
                else {
                    if (err.errorCode === "user_login_error") {
                        await onSignIn(redirect);
                    }
                    else {
                        ERROR = err.message;
                        console.error("Non-interactive error:", err);
                    }
                }
            });
            return tokenData;
        };
        const onSignIn = async (redirect) => {
            if (redirect) {
                return msalApp.loginRedirect({
                    ...utils_1.GRAPH_REQUESTS.LOGIN,
                    redirectUri: authenticatorProps.redirectUri,
                });
            }
            const loginResponse = await msalApp
                .loginPopup(utils_1.GRAPH_REQUESTS.LOGIN)
                .catch((err) => {
                ERROR = err.errorMessage;
            });
            if (loginResponse) {
                USER_ACCOUNT = loginResponse.account;
                ERROR = "";
                const tokenResponse = await acquireToken(utils_1.GRAPH_REQUESTS.LOGIN, redirect).catch((err) => {
                    ERROR = err.errorMessage;
                });
                AUTH_STATE = {
                    ...AUTH_STATE,
                    error: ERROR,
                    isAuthenticated: true,
                    user: USER_ACCOUNT,
                    token: tokenResponse ? tokenResponse.accessToken : "",
                };
                return tokenResponse;
            }
        };
        const updateGraphData = async (token) => {
            const extraToFetch = "?$select=businessPhones,displayName,givenName,jobTitle,mail,mobilePhone,officeLocation,preferredLanguage,surname,userPrincipalName,id,employeeId";
            const gProfile = await utils_1.fetchMsGraph(`${utils_1.GRAPH_ENDPOINTS.ME}${extraToFetch}`, token).catch(() => {
                ERROR = "Unable to fetch Graph profile.";
            });
            if (gProfile) {
                GRAPH_PROFILE = gProfile;
            }
            const gMyGroups = await utils_1.fetchMsGraph(utils_1.GRAPH_ENDPOINTS.GROUPS, token).catch(() => {
                ERROR = "Unable to fetch Graph my groups.";
            });
            if (gMyGroups) {
                GRAPH_GROUPS = gMyGroups.value;
            }
            const account = msalApp.getAccount();
            USER_ACCOUNT = account;
            const graph = {
                profile: gProfile,
                groups: gMyGroups.value,
            };
            AUTH_STATE = {
                ...AUTH_STATE,
                error: ERROR,
                isAuthenticated: true,
                user: USER_ACCOUNT,
                graph,
            };
            return graph;
        };
        const onSignOut = () => {
            ERROR = "";
            USER_ACCOUNT = {};
            GRAPH_PROFILE = {};
            GRAPH_GROUPS = [];
            AUTH_STATE = {
                error: ERROR,
                isAuthenticated: false,
                token: "",
                user: USER_ACCOUNT,
                graph: {
                    profile: GRAPH_PROFILE,
                    groups: GRAPH_GROUPS,
                },
            };
            msalApp.logout();
        };
        return (react_1.default.createElement(Component, Object.assign({}, props, { account: USER_ACCOUNT, acquireToken: (redirect) => acquireToken(utils_1.GRAPH_REQUESTS.LOGIN, redirect || useRedirectFlow), error: ERROR, getAuthState: () => AUTH_STATE, graphGroups: GRAPH_GROUPS, graphProfile: GRAPH_PROFILE, onSignIn: (redirect) => onSignIn(redirect || useRedirectFlow), onSignOut: () => onSignOut(), updateGraphData: (token) => updateGraphData(token) })));
    };
    return AppWithAuthenticator;
};
exports.withAuthenticator = withAuthenticator;
//# sourceMappingURL=index.js.map